import { useState } from 'react';
import { hashPassword } from '../../utils/hashUtil';
import { useNavigate } from 'react-router-dom';
import Logo from '../../assets/svg/policia.svg';
import './Register.css';

import { registerUser, verifyUser } from '../../services/authService';
import { login } from '../../services/authService';
import { useModulos } from '../../modulosContext';
import { useUser } from '../../userContext';

import PopupMensaje from '../../iu/popupMensaje/PopupMensaje';
const Register = () => {
    const [popupMensaje, setPopupMensaje] = useState('');
    const [popupKey, setPopupKey] = useState(0);
    const handlePopupClose = () => {
        setPopupMensaje('');
        setPopupKey((prevKey) => prevKey + 1);
    };


    const { modulosPorDefecto } = useModulos();
    const { iniciarSesion, setToken } = useUser();
    const navigate = useNavigate();
    const [nombre, setNombre] = useState('');
    const [apellidoPaterno, setApellidoPaterno] = useState('');
    const [apellidoMaterno, setApellidoMaterno] = useState('');
    const [telefono, setTelefono] = useState('');
    const [correo, setCorreo] = useState('');
    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [section, setSection] = useState(1);

    const [showPassword, setShowPassword] = useState(false);

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        try {
            //verifica que los campos no esten vacios
            if (!nombre || !apellidoPaterno || !apellidoMaterno || !telefono || !correo || !password || !repeatPassword) {
                setPopupMensaje('Por favor, llena todos los campos');
                return;
            }


            //verifica que el correo sea valido
            const user = await verifyUser(correo);
            if (user) {
                setPopupMensaje('Ya existe un usuario con este correo');
                return;
            }

            //verifica que la contraseña sea igual a la contraseña repetida
            if (password !== repeatPassword) {
                setPopupMensaje('Las contraseñas no coinciden');
                return;
            }

            // Comprueba que la contraseña tenga una mayúscula, una minúscula y un número
            if (!/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/.test(password)) {
                setPopupMensaje('La contraseña debe contener al menos una mayúscula, una minúscula y un número');
                return;
            }


            //comprueba que la contraseña tenga al menos 8 caracteres
            if (password.length < 8) {
                setPopupMensaje('La contraseña debe tener al menos 8 caracteres');
                return;
            }
            const hashedPassword = await hashPassword(password);
            const userData = await registerUser(correo, hashedPassword, nombre, apellidoPaterno, apellidoMaterno, telefono, modulosPorDefecto, 'user');

            const data = await login(correo, hashedPassword);
            if (!data.accessToken) {
                setPopupMensaje('Acceso denegado');
            } else {
                setToken(data.accessToken);
                const nombreCompleto = `${data.user.nombre} ${data.user.apellido1} ${data.user.apellido2}`;
                iniciarSesion(data.user.id, nombreCompleto, data.user.correo, data.user.telefono, data.user.modulos, data.user.rol);
                navigate('/inicio');
            }
        } catch (error) {
            console.error('Error al registrar usuario:', error);
            setPopupMensaje('Error al registrar usuario. Por favor, inténtalo de nuevo.');
        }
    };

    const handleNextSection = () => {

        //verifica que los campos de la primera seccion no esten vacios
        if (!nombre || !apellidoPaterno || !apellidoMaterno || !telefono) {
            setPopupMensaje('Por favor, llena todos los campos');
            return;
        }
        //comprueba que el nombre no tenga numeros
        if (/\d/.test(nombre)) {
            setPopupMensaje('El nombre no debe contener números');
            return;
        }

        //comprueba que el apellido paterno no tenga numeros
        if (/\d/.test(apellidoPaterno)) {
            setPopupMensaje('El apellido paterno no debe contener números');
            return;
        }

        //comprueba que el apellido materno no tenga numeros
        if (/\d/.test(apellidoMaterno)) {
            setPopupMensaje('El apellido materno no debe contener números');
            return;
        }
        //comprobar que el aprellido paterno y materno no tengan espacios o caracteres especiales
        if (/\W/.test(apellidoPaterno) || /\W/.test(apellidoMaterno)) {
            setPopupMensaje('El apellido paterno y materno no deben contener espacios o caracteres especiales');
            return;
        }
        //comprueba que el telefono no tenga letras
        if (isNaN(telefono)) {
            setPopupMensaje('El teléfono debe ser un número');
            return;
        }

        //comprueba que el telefono tenga 10 digitos
        if (telefono.length !== 10) {
            setPopupMensaje('El teléfono debe tener 10 dígitos');
            return;
        }

        //comprueba que el telefono sea un numero
        if (isNaN(telefono)) {
            setPopupMensaje('El teléfono debe ser un número');
            return;
        }
        setSection(2);
    };

    const handleNextSectionBack = () => {
        setSection(1);
    };

    const handleIniciar = () => {
        navigate('/login');
    }
    return (
        <div className="main">
            <h1 className="register-title">Registro de Usuario</h1>
            <div className="register-card">
                <img className="register-logo" src={Logo} alt="logo" />
                <form onSubmit={handleRegister}>
                    {/* Primera sección del formulario */}
                    {section === 1 && (
                        <>
                            <div className="form-group">
                                <label>Nombre (s)</label>
                                <input
                                    id="nombre"
                                    className='input-register'
                                    type="text"
                                    value={nombre}
                                    onChange={(e) => setNombre(e.target.value)}
                                />
                            </div>
                            <div className="form-group">
                                <label>Apellido Paterno</label>
                                <input
                                    id="apellidoPaterno"
                                    className='input-register'
                                    type="text"
                                    value={apellidoPaterno}
                                    onChange={(e) => setApellidoPaterno(e.target.value)}
                                />
                            </div>
                            <div className="form-group">
                                <label>Apellido Materno</label>
                                <input
                                    id="apellidoMaterno"
                                    className='input-register'
                                    type="text"
                                    value={apellidoMaterno}
                                    onChange={(e) => setApellidoMaterno(e.target.value)}
                                />
                            </div>
                            <div className="form-group">
                                <label>Número de Teléfono</label>
                                <input
                                    id="telefono"
                                    className='input-register'
                                    type="text"
                                    value={telefono}
                                    onChange={(e) => setTelefono(e.target.value)}
                                />
                            </div>
                            <button className="boton-primario" type="button" onClick={handleNextSection}>
                                Siguiente
                            </button>
                            <div className="register-link">
                                ¿Ya tienes cuenta? <div onClick={handleIniciar}>Iniciar sesión</div>
                            </div>
                        </>
                    )}

                    {/* Segunda sección del formulario */}
                    {section === 2 && (
                        <>
                            <div className="form-group">
                                <label>Correo</label>
                                <input
                                    id="correo"
                                    className='input-register'
                                    type="email"
                                    value={correo}
                                    onChange={(e) => setCorreo(e.target.value)}
                                />
                            </div>
                            <div className="form-group">
                                <label>Contraseña</label>
                                <input
                                    id="password"
                                    className='input-register'
                                    type={showPassword ? "text" : "password"}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                            <div className="form-group">
                                <label>Repetir Contraseña</label>
                                <input
                                    id="repeatPassword"
                                    className='input-register'
                                    type={showPassword ? "text" : "password"}
                                    value={repeatPassword}
                                    onChange={(e) => setRepeatPassword(e.target.value)}
                                />
                                <div className='show-password-container'>
                                    <input
                                        type="checkbox"
                                        id="show-password"
                                        checked={showPassword}
                                        onChange={toggleShowPassword}
                                    />
                                    <label htmlFor="show-password">Mostrar contraseñas</label>
                                </div>
                            </div>
                            <div className='register-button-container'>
                                <button className="boton-secundario" type="button" onClick={handleNextSectionBack}>
                                    Atras
                                </button>
                                <button className="boton-primario" type="submit">
                                    Registrarse
                                </button>
                            </div>

                            <div className="register-link">
                                ¿Ya tienes cuenta? <div onClick={handleIniciar}>Iniciar sesión</div>
                            </div>
                        </>
                    )}
                </form>
            </div>
            {popupMensaje && (
                <PopupMensaje
                    key={popupKey}
                    mensaje={popupMensaje}
                    onClose={handlePopupClose}
                />
            )}
        </div>
    );
};

export default Register;
